import JsCookie from 'js-cookie'
import { isEmbedded } from '@/utils/iframe-support'

// This one will help save data to SessionStorage when user checkout via iframe
// Because browser doesn't support save Cookie for 3rd
class TamaraCookie {
  isEmbedded = isEmbedded()

  get = (key) => {
    if (this.isEmbedded) {
      return window.sessionStorage.getItem(key)
    }

    return JsCookie.get(key)
  }

  set = (key, value, options = {}) => {
    if (this.isEmbedded) {
      return window.sessionStorage.setItem(key, value)
    }

    return JsCookie.set(key, value, options)
  }

  remove = (key, options = {}) => {
    if (this.isEmbedded) {
      return window.sessionStorage.removeItem(key)
    }

    return JsCookie.remove(key, options)
  }
}

export default new TamaraCookie()
